import { STEPPER_GLOBAL_OPTIONS, StepperSelectionEvent } from '@angular/cdk/stepper';
import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { NgScrollbar } from 'ngx-scrollbar';
import {
  catchError,
  finalize,
  firstValueFrom,
  forkJoin,
  map,
  Observable,
  of,
  Subscription,
  switchMap,
  throwError,
} from 'rxjs';
import { CfgQuestionarioComponent } from 'src/app/components/cfg-questionario/cfg-questionario.component';
import { CfgStampaComponent } from 'src/app/components/cfg-stampa/cfg-stampa.component';
import {
  InclusioneModuliComponent,
  ModuliInclusi,
} from 'src/app/components/inclusione-moduli/inclusione-moduli.component';
import {
  Filters,
  FnCaricamentoDati,
  SortBy,
} from 'src/app/components/lista-tabellare/classes/lista-tabellare-data-source';
import {
  BottoniListaEvent,
  Colonna,
  Filtri,
  ListaTabellareComponent,
} from 'src/app/components/lista-tabellare/lista-tabellare.component';
import { DialogAssociaFiguraAziendaleComponent } from 'src/app/components/selezione-elementi-questionario/dialog/dialog-associa-figura-aziendale/dialog-associa-figura-aziendale.component';
import { SelezioneAzioniBuonepratichePolicyComponent } from 'src/app/components/selezione-elementi-questionario/metodi-selezione/selezione-azioni-buonepratiche-policy/selezione-azioni-buonepratiche-policy.component';
import { SelezioneCertificazioniPolicyComponent } from 'src/app/components/selezione-elementi-questionario/metodi-selezione/selezione-certificazioni-policy/selezione-certificazioni-policy.component';
import { SelezioneImpegniPolicyComponent } from 'src/app/components/selezione-elementi-questionario/metodi-selezione/selezione-impegni-policy/selezione-impegni-policy.component';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import { DATA_SERVICE } from 'src/app/components/totali-cruscotto/data-service.token';
import { TotaliCruscottoComponent } from 'src/app/components/totali-cruscotto/totali-cruscotto.component';
import { DialogCreaTemplateMailComponent } from 'src/app/page/analisi-materialita/materialita/dialog/dialog-crea-template-mail/dialog-crea-template-mail.component';
import { DialogCreaComitatiComponent } from 'src/app/page/configurazioni/cfg-comitati/dialog/dialog-crea-comitati/dialog-crea-comitati.component';
import { DialogAssegnazioniComponent } from 'src/app/page/sintesi-sostenibilita/dialog/dialog-assegnazioni/dialog-assegnazioni.component';
import { DialogCompilazioneFigureComponent } from 'src/app/page/sintesi-sostenibilita/dialog/dialog-compilazione-figure/dialog-compilazione-figure.component';
import { AutovalutazioniService } from 'src/app/services/autovalutazioni/autovalutazioni.service';
import { AziendaService } from 'src/app/services/azienda/azienda.service';
import { BilancioService } from 'src/app/services/bilancio/bilancio.service';
import { GruppoCfgStampa } from 'src/app/services/config-stampe/config-stampe.service';
import { ImportazioniService } from 'src/app/services/importazioni/importazioni.service';
import { MaterialitaService } from 'src/app/services/materialita/materialita.service';
import { PianoService } from 'src/app/services/piano/piano.service';
import { PolicyService, PolicySostenibilita } from 'src/app/services/policy/policy.service';
import { Settore, SettoriService, SottoSettore } from 'src/app/services/settori/settori.service';
import { ElementiCruscotto, SintesiService } from 'src/app/services/sintesi/sintesi.service';
import { UtenteService } from 'src/app/services/utente/utente.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { SelezionaComitatiComponent } from '../seleziona-comitati/seleziona-comitati.component';
import { SelezionaPerimetroDestinatariComponent } from '../seleziona-perimetro-destinatari/seleziona-perimetro-destinatari.component';

@Component({
  selector: 'app-dialog-crea-policy-sostenibilita',
  templateUrl: './dialog-crea-policy-sostenibilita.component.html',
  styleUrls: ['./dialog-crea-policy-sostenibilita.component.scss'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: true },
    },
    { provide: DATA_SERVICE, useClass: PolicyService },
  ],
  standalone: false,
})
export class DialogCreaPolicySostenibilitaComponent implements OnInit, AfterViewInit {
  @ViewChild('stepper') stepper!: MatStepper;
  @ViewChild('btnAvanti') btnAvanti!: MatButton;
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;
  @ViewChild(CfgQuestionarioComponent) componenteSurvey!: CfgQuestionarioComponent;
  @ViewChild(SelezioneImpegniPolicyComponent)
  componenteSelImpegniPolicy!: SelezioneImpegniPolicyComponent;
  @ViewChild(SelezioneAzioniBuonepratichePolicyComponent)
  componenteSelAzioneBPPolicy!: SelezioneAzioniBuonepratichePolicyComponent;
  @ViewChild(SelezioneCertificazioniPolicyComponent)
  componenteSelCertificazioniPolicy!: SelezioneCertificazioniPolicyComponent;
  @ViewChild(SelezionaComitatiComponent) selezionaComitatiPolicy!: SelezionaComitatiComponent;
  @ViewChild(SelezionaPerimetroDestinatariComponent)
  selezionaPerimetroDestinatari!: SelezionaPerimetroDestinatariComponent;
  @ViewChild('tabella') tabella!: ListaTabellareComponent;
  @ViewChild('scrollConfStampa') scrollConfStampa!: NgScrollbar;
  @ViewChild(CfgStampaComponent) cfgStampaComponent!: CfgStampaComponent;
  @ViewChild(InclusioneModuliComponent) inclusioneModuli!: InclusioneModuliComponent;
  @ViewChild('totaliCruscotto') cmpTotaliCruscotto!: TotaliCruscottoComponent;

  public isPermessoInvioMail: boolean = this.utenteService.isPermessoAttivo('INVIO_MAIL');
  public isPermessoSoloRead: boolean = false;
  public mappaAnnoSettore: { [anno: string]: { [settore: string]: boolean } } = {};
  public arrayAnni: string[] = [];
  public settoriAzienda: Settore[] = [];
  public guidaDescrizione: string | undefined = undefined;
  public mostraDescrizione: boolean = false;
  public arraySottoSettori: SottoSettore[] = [];
  public settoreGenerale: Settore | undefined = undefined;

  public loadingAnalisiMaterialita = false;
  public loadingAutovalutazione = false;
  public mostraBottoneAssegnazioni: boolean = false;
  public idQuestionario: string | undefined = undefined;

  public objQuestionarioImpegni = [];
  public objQuestionarioAzioniBP = [];
  public objQuestionarioCertificazioni = [];
  public objQuestionarioComitati = [];

  private _subCambioValoriSettoreSottoSettore: Subscription | undefined = undefined;
  private _subValueChangeSettore: Subscription | undefined = undefined;
  private _subValueChangeTipoSettore: Subscription | undefined = undefined;

  public idModuliInclusi: ModuliInclusi | undefined;

  private _policy: any = {};
  public selectedStepIndex: number | undefined = undefined;

  get isMaterialitaSelezionata(): boolean {
    return !!this.inclusioneModuli?.formInclusioneModuli.get('idMaterialita')?.value;
  }

  get policy() {
    return this._policy;
  }

  public formPolicySostenibilita = new FormGroup({
    id: new FormControl<string | undefined>(undefined, {
      nonNullable: true,
      validators: [],
    }),

    idAzienda: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required],
    }),

    anno: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required],
    }),

    tipoSettore: new FormControl<'GENERALE' | 'SPECIFICO' | undefined>(undefined, {
      nonNullable: true,
      validators: [Validators.required],
    }),

    settori: new FormControl<Settore | undefined>(undefined, {
      nonNullable: true,
      validators: [Validators.required],
    }),

    sottoSettori: new FormControl<SottoSettore[]>([], {
      nonNullable: true,
    }),

    tipo: new FormControl<string>('POLICY', {
      nonNullable: true,
      validators: [],
    }),
  });

  public filtri: Filtri[] = [
    {
      titolo: 'Figure Aziendali',
      forControlName: 'figureAziendali',
      input: 'text',
    },
    {
      titolo: 'Nome',
      forControlName: 'nome',
      input: 'text',
    },
    {
      titolo: 'Cognome',
      forControlName: 'cognome',
      input: 'text',
    },
    {
      titolo: 'Email',
      forControlName: 'email',
      input: 'text',
    },
  ];

  public colonne: { [key: string]: Colonna } = {
    stakeholder: {
      title: 'Figure Aziendali',
      value: 'figura',
    },
    tipologia: {
      title: 'Nome',
      value: 'nome',
    },
    email: {
      title: 'Email',
      value: 'email',
    },
    stato: {
      title: 'Stato',
      value: (record: any) => {
        if (record?.stato === 'ROSSO') {
          // non compilato
          return '<div style="display: flex;justify-content: center;align-items:center;background-color:#cf5b61;width:25px;text-align: center;border-radius: 15px;height:25px"></div>';
        } else if (record?.stato === 'GIALLO') {
          // ha inviato la mail ma non è stato compilato (valore solo per gli stakeholder con modalita compilazione "INVIAMAIL")
          return '<div style="display: flex;justify-content: center;align-items:center;background-color:#c7a045;width:25px;text-align: center;border-radius: 15px;height:25px"></div>';
        } else if (record?.stato === 'VERDE') {
          // compilato
          return '<div style="display: flex;justify-content: center;align-items:center;background-color:#729373;width:25px;text-align: center;border-radius: 15px;height:25px"></div>';
        } else {
          return '';
        }
      },
    },
    history: {
      type: 'button',
      buttonIcon: this.isPermessoSoloReadFunx() ? 'visibility' : 'history_edu',
      title: this.isPermessoSoloReadFunx() ? 'Visualizza' : 'Compila',
      buttonId: 'compila',
      buttonMostraSempre: true,
      sortable: false,
    },

    modifica: {
      type: 'button',
      buttonIcon: 'person_edit',
      title: 'Modifica',
      buttonId: 'modifica',
      nascondiButton: (record) => record?.stato === 'VERDE' || this.isPermessoSoloReadFunx(),
      buttonMostraSempre: true,
    },
  };

  constructor(
    private readonly importazioniService: ImportazioniService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<DialogCreaPolicySostenibilitaComponent>,
    private readonly materialitaService: MaterialitaService,
    private readonly utilityService: UtilityService,
    private readonly aziendaService: AziendaService,
    private readonly settoriService: SettoriService,
    private readonly sintesiService: SintesiService,
    private readonly bilancioService: BilancioService,
    private readonly policyService: PolicyService,
    private readonly pianoService: PianoService,
    private readonly autovalutazioniService: AutovalutazioniService,
    private readonly utenteService: UtenteService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      policy: PolicySostenibilita;
    },
  ) {
    this.idModuliInclusi = {
      idMaterialita: data.policy?.idMaterialita,
      idBilancioSostenibilita: data.policy?.idBilancioSostenibilita,
      idSintesiSostenibilita: data.policy?.idSintesiSostenibilita,
      idAutovalutazioneCompilata: data.policy?.idAutovalutazioneCompilata,
      idPianoSostenibilita: data.policy?.idPianoSostenibilita,
    };
  }

  ngOnInit(): void {
    const annoCorrente = new Date().getFullYear();

    // Aggiungi gli anni indietro di 5 anni e in avanti di 1 anno all'array
    for (let i = annoCorrente - 5; i <= annoCorrente + 1; i++) {
      this.arrayAnni.push(i.toString());
    }

    // Aggiungo l'anno di un modulo precedente agli anni calcolati.
    // Se ho creato un modulo di ques'anno allora tramite questa gestione l'anno prossimo riuscirò a viusalizzarlo
    if (this.data.policy) {
      const { anno } = this.data.policy;
      if (anno && !this.arrayAnni.includes(anno)) {
        this.arrayAnni.push(anno);
      }
    }

    this.aziendaService.azienda.then((azienda) => {
      if (azienda) {
        this.formPolicySostenibilita.get('idAzienda')?.setValue(azienda.id);
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.init();
    }, 0);

    this.gestioneStepperPolicy();

    this.isPermessoSoloRead = this.isPermessoSoloReadFunx();

    if (this.isPermessoSoloRead) {
      this.formPolicySostenibilita.disable();
    }
  }

  isPermessoSoloReadFunx() {
    const isEdit = this.utenteService.isPermessoAttivo('EDIT_POLICY');
    const isCreate = this.utenteService.isPermessoAttivo('CREATE_POLICY');
    const statoArchiviato = this.isArchiviato();
    return (!isEdit && !isCreate) || statoArchiviato;
  }

  /**
   * Questionario pubblicato
   * @returns true === PUBBLICATO
   */
  public isPubblicato(): boolean {
    return this.policy?.stato === 'PUBBLICATO' || this.data?.policy?.stato === 'PUBBLICATO';
  }
  public isArchiviato(): boolean {
    return this.policy?.stato === 'ARCHIVIATO' || this.data?.policy?.stato === 'ARCHIVIATO';
  }

  async init() {
    this.spinnerOver.show();

    await this._caricaSettori();

    this._subValueChangeSettore = this.formPolicySostenibilita
      .get('settori')!
      .valueChanges.subscribe((value) => {
        if (value) {
          this.arraySottoSettori =
            this.settoriAzienda.find((sett) => sett.id === value.id)?.sottoSettori || [];
        }

        this._updateSottoSettoriSelezionati();
      });

    this._subValueChangeTipoSettore = this.formPolicySostenibilita
      .get('tipoSettore')
      ?.valueChanges.subscribe((value) => {
        if (value === 'GENERALE') {
          this.formPolicySostenibilita.get('settori')?.setValue(this.settoreGenerale);
        } else if (value === 'SPECIFICO') {
          this.formPolicySostenibilita
            .get('settori')
            ?.setValue(this.settoriAzienda?.length ? this.settoriAzienda[0] : undefined);
        }
      });

    if (this.data.policy) {
      await this._setDatiPolicy(this.data.policy);
    } else if (this.settoriAzienda?.length) {
      // Preselezione settore
      this.formPolicySostenibilita.get('tipoSettore')?.setValue('SPECIFICO');
      this.formPolicySostenibilita.get('settori')?.setValue(this.settoriAzienda[0]);
    } else {
      this.formPolicySostenibilita.get('tipoSettore')?.setValue('GENERALE');
    }

    this.spinnerOver.hide();

    if (this.data?.policy?.stato === 'PUBBLICATO') {
      this._caricaStepTematiche();
    }
  }

  ngOnDestroy(): void {
    this._subValueChangeSettore?.unsubscribe();
    this._subValueChangeTipoSettore?.unsubscribe();
    this._subCambioValoriSettoreSottoSettore?.unsubscribe();
  }

  /**
   * Setta nel formGroup i dati della policy
   * @param policy
   */
  private async _setDatiPolicy(policy: PolicySostenibilita) {
    let settoreSel: Settore | undefined = policy.settori?.length ? policy.settori[0] : undefined;

    Object.keys(policy).forEach((value) => {
      if (value === 'settori') {
        // Settore si imposta per ultimo, per non far scattare il change quando non è ancora settato l'array dei sottosettori
        settoreSel = (policy as any)[value][0];
      } else {
        this.formPolicySostenibilita.get(value)?.setValue((policy as any)[value]);
      }
    });

    if (settoreSel) {
      if (!this.settoriAzienda.find((set) => set.id === settoreSel!.id)) {
        // Il settore del bilancio non è negli array dei settori azienda.
        // Potrebbe essere stato tolto a posteriori, dopo la creazione del policy.
        // Per non lasciare il campo vuoto, si setta nell'array il settore che viene dal policy.
        this.settoriAzienda = [settoreSel];
      }

      this.formPolicySostenibilita.get('settori')?.setValue(settoreSel);
    }

    //Disabilito campi in modifica
    if (this.formPolicySostenibilita.get('id')?.value) {
      this.formPolicySostenibilita.disable();
    }
  }

  /**
   * Bottone indietro
   * @returns step precedente
   */
  public indietro() {
    switch (this.stepper.selectedIndex) {
      case 0:
        return true;
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
        this.stepper.previous();
        return true;
      default:
        return null;
    }
  }

  /**
   * Bottone avanti che salva i dati sullo step attuale
   * @returns metodo in base allo step attuale
   */
  public async avanti() {
    let result: boolean = false;
    this.spinnerOver.show();
    switch (this.stepper.selectedIndex) {
      case 0:
        result = await this._salvaStepPolicy();
        break;
      case 1:
        result = await this._salvaStepTematiche();
        break;
      case 2:
        result = await this._salvaStepImpengi();
        break;
      case 3:
        result = await this._salvaStepAzioniBP();
        break;
      case 4:
        result = await this._salvaStepCertificazioni();
        break;
      case 5:
        result = await this._salvaStepComitati();
        break;
      case 6:
        result = true;
        break;
      case 7:
        result = await this._salvaPerimetriDestinatari();
        break;
      default:
        return;
    }

    this.spinnerOver.hide();

    return result;
  }

  public async avantiHTML() {
    if (this.isPermessoSoloRead || (await this.avanti())) {
      return this.stepper.next();
    }
  }

  /**
   * Viene disabilitato per non spammare il bottone avanti mentre stanno caricando i dati
   */
  disabilitaBottoneAvanti() {
    setTimeout(() => {
      this.btnAvanti.disabled = true;
    }, 0);
  }

  /* Mi carica i dati nello step selezionato */
  cambioStep(event: StepperSelectionEvent) {
    this.mostraBottoneAssegnazioni = false;

    switch (event.selectedIndex) {
      case 0:
        return;

      case 1:
        this.disabilitaBottoneAvanti();
        return this._caricaStepTematiche();

      case 2:
        this.mostraBottoneAssegnazioni = true;
        this.disabilitaBottoneAvanti();

        return this._getImpegniPolicy();

      case 3:
        this.mostraBottoneAssegnazioni = true;
        this.disabilitaBottoneAvanti();

        return this._getAzioniBPPolicy();

      case 4:
        this.mostraBottoneAssegnazioni = true;
        this.disabilitaBottoneAvanti();

        return this._getCertificazioniPolicy();

      case 5:
        return this._getComitatiPolicy();

      case 6:
        return this._getCruscottoPolicy();

      case 7:
        return this._getPerimetriDestinatari();

      case 8:
        return this.cfgStampaComponent.caricaStampa();

      default:
        return;
    }
  }

  compareById(elemento1: any, elemento2: any): boolean {
    return elemento1?.id === elemento2?.id; // Sostituisci "id" con la proprietà univoca dei settori
  }

  /**
   * Gestione caricamento settori e sotto settori
   */
  private async _caricaSettori() {
    this.spinnerOver.show();
    try {
      const risp = await firstValueFrom(
        forkJoin({
          generale: this.settoriService.getSettoreGenerale().pipe(
            catchError((err) => {
              console.error('ERRORE GET SETTORE GENERALE : ', err);
              // Errore recupero settore generale, potrebbe non esistere. Si torna undefined
              return of(undefined);
            }),
          ),
          specifici: this.aziendaService.getSettoriAzienda(),
          policyCreate: this.policyService.getPolicySostenibilita(0, 1000, '', []).pipe(
            catchError((err) => {
              console.error('ERRORE GET POLICY CREATE : ', err);
              return of(undefined);
            }),
          ),
        }),
      );

      this.settoriAzienda = risp?.specifici || [];
      this.settoreGenerale = risp?.generale;

      if (risp?.policyCreate?.content) {
        this.mappaAnnoSettore = this.settoriService.getModuliDaCreare(risp?.policyCreate?.content);
      }

      if (!this.settoriAzienda?.length && !this.settoreGenerale) {
        console.error('NESSUN SETTORE DISPONIBILE, IMPOSSIBILE PROSEGUIRE');
      }

      this.arraySottoSettori =
        this.settoriAzienda.find(
          (sett) => sett.id === this.formPolicySostenibilita.get('settori')?.value?.id,
        )?.sottoSettori || [];

      this.spinnerOver.hide();
    } catch (error) {
      console.error(error);

      this.spinnerOver.hide();

      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: 'Errore nel recupero dei settori',
        bottoni: [{ nome_btn: 'Ok' }],
      });

      this.dialogRef.close();
    }
  }

  private _updateSottoSettoriSelezionati() {
    const sottoSettoriSel = this.formPolicySostenibilita.get('sottoSettori')?.value || [];

    const sottoSettoriaggiornati = sottoSettoriSel.filter((sottoSettSel) => {
      return (
        this.arraySottoSettori &&
        sottoSettSel.id &&
        !!this.arraySottoSettori.find((sottoSett) => {
          return sottoSett.id === sottoSettSel.id;
        })
      );
    });

    this.formPolicySostenibilita.get('sottoSettori')?.setValue(sottoSettoriaggiornati || []);
  }

  /**
   * Metodo che mi fa la get del questionario della Policy
   * @param id id Policy
   * @returns
   */
  private _getQuestionarioPolicy(id: string) {
    return this.policyService
      .getQuestionarioPolicy(id)
      .pipe(
        catchError((err) => {
          console.error(err);
          if (err.status === 404) {
            return of(false);
          } else {
            return throwError(() => err);
          }
        }),
      )
      .pipe(
        map((policy) => {
          if (policy) {
            this._policy = policy;
          }
          return policy;
        }),
      );
  }

  //******************************* METODI CARICAMENTO PER cambioStep() *************************************/

  private _caricaStepTematiche() {
    const id = this.formPolicySostenibilita.get('id')?.value;

    const idSettore = (this.formPolicySostenibilita.get('settori')?.value as Settore).id;
    this.componenteSurvey.datiInizialiCfgQuestionario(idSettore);

    if (!id) {
      return;
    }

    this.spinnerOver.show();

    this._getQuestionarioPolicy(id).subscribe({
      next: (policy: any) => {
        if (policy) {
          this._policy = policy;
          this.completaStep();
        }
        this.btnAvanti.disabled = false;
        this.spinnerOver.hide();
      },
      error: (err: any) => {
        console.error(err);
        this.btnAvanti.disabled = false;

        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: 'Errore nel recupero della policy',
          bottoni: [{ nome_btn: 'Ok' }],
        });
        this.spinnerOver.hide();
      },
    });
  }

  /**
   * Get ws impegni policy
   * @returns
   */
  private async _getImpegniPolicy() {
    const id = this.formPolicySostenibilita.get('id')?.value;

    if (!id) {
      return false;
    }

    this.spinnerOver.show();
    return firstValueFrom(
      this.policyService.getImpegniPolicy(id).pipe(
        finalize(() => (this.btnAvanti.disabled = false)),
        map((esito) => {
          this.objQuestionarioImpegni = esito;
          this.componenteSelImpegniPolicy.objQuestionario = esito;
          this.spinnerOver.hide();
          return true;
        }),
        catchError((err) => {
          console.error(err);
          this.utilityService.openDialog({
            titolo: 'Attenzione',
            descrizione: 'Errore nel recupero degli impegni',
            bottoni: [{ nome_btn: 'Ok' }],
          });
          this.spinnerOver.hide();
          return of(false);
        }),
      ),
    );
  }

  /**
   * Get ws azioni buone pratiche policy
   * @returns
   */
  private async _getAzioniBPPolicy(): Promise<boolean> {
    const id = this.formPolicySostenibilita.get('id')?.value;

    if (!id) {
      return false;
    }
    this.spinnerOver.show();

    return firstValueFrom(
      this.policyService.getAzioniBPPolicy(id).pipe(
        finalize(() => (this.btnAvanti.disabled = false)),
        map((esito) => {
          this.objQuestionarioAzioniBP = esito;
          this.componenteSelAzioneBPPolicy.objQuestionario = esito;
          this.spinnerOver.hide();
          return true;
        }),
        catchError((err) => {
          console.error(err);
          this.utilityService.openDialog({
            titolo: 'Attenzione',
            descrizione: 'Errore nel recupero delle azioni buone pratiche',
            bottoni: [{ nome_btn: 'Ok' }],
          });
          this.spinnerOver.hide();
          return of(false);
        }),
      ),
    );
  }

  /**
   * Get Certificazioni Policy
   * @returns
   */
  private _getCertificazioniPolicy() {
    const id = this.formPolicySostenibilita.get('id')?.value;

    if (!id) {
      return;
    }
    this.spinnerOver.show();
    this.policyService
      .getCertificazioniPolicy(id)
      .pipe(finalize(() => (this.btnAvanti.disabled = false)))
      .subscribe({
        next: (esito) => {
          this.objQuestionarioCertificazioni = esito;
          this.spinnerOver.hide();
        },
        error: (err) => {
          console.error(err);
          this.utilityService.openDialog({
            titolo: 'Attenzione',
            descrizione: 'Errore nel recupero delle certificazioni',
            bottoni: [{ nome_btn: 'Ok' }],
          });
          this.spinnerOver.hide();
        },
      });
  }

  /**
   * Get Comitati Policy
   * @returns
   */
  private _getComitatiPolicy() {
    const id = this.formPolicySostenibilita.get('id')?.value;

    if (!id) {
      return;
    }

    return firstValueFrom(this.selezionaComitatiPolicy.getComitatiConFigureAziendali());
  }

  /**
   * Get Dati Cruscotto policy
   */
  private _getCruscottoPolicy() {
    this.spinnerOver.show();
    this.tabella.caricaDati();

    this.cmpTotaliCruscotto.getTotaliCruscotto();
    this.spinnerOver.hide();
  }

  /**
   * Carica i dati della tabella cruscotto policy
   * @param page
   * @param pageSize
   * @param ricerca
   * @param filters
   * @param sortBy
   * @returns
   */
  public fnCaricamentoDatiCruscotto: FnCaricamentoDati = (
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ) => {
    const idPolicySostenibilita = this.formPolicySostenibilita.get('id')?.value;

    if (idPolicySostenibilita) {
      return this.policyService.getCruscotti(
        idPolicySostenibilita,
        page,
        pageSize,
        ricerca,
        filters,
        sortBy,
      );
    } else {
      return of(false);
    }
  };

  /**
   * Get Perimetri e Destinatari da compilare
   * @returns
   */
  private _getPerimetriDestinatari() {
    const id = this.formPolicySostenibilita.get('id')?.value;

    if (!id) {
      return false;
    }

    return firstValueFrom(
      this.selezionaPerimetroDestinatari.getPerimetriDestinatari().pipe(
        map(() => {
          return of(true);
        }),
        catchError(() => {
          return of(false);
        }),
      ),
    );
  }

  //******************************* METODI SALVATAGGIO PER avanti() *************************************/

  /**
   * Metodo salvataggio STEP 1 Policy
   * @returns
   */
  private async _salvaStepPolicy(): Promise<boolean> {
    const idPolicy = this.formPolicySostenibilita.get('id')?.value;
    if (idPolicy) {
      return true;
    }

    if (this.formPolicySostenibilita.valid) {
      const dialog = await this.utilityService.openDialog({
        titolo: 'Avviso',
        descrizione: 'Continuando non sarà più possibile modificare queste informazioni.',
        bottoni: [
          {
            nome_btn: 'Annulla',
            id_btn: 'N',
          },
          {
            nome_btn: 'Avanti',
            id_btn: 'S',
          },
        ],
      });

      const valDialog = await firstValueFrom(dialog.beforeClosed());
      if (valDialog === 'N') {
        return false;
      }
    }

    if (this.formPolicySostenibilita.valid) {
      let formCrtSostenibilita = this.formPolicySostenibilita.getRawValue();

      const nuovaPolicy = {
        ...formCrtSostenibilita,
        idMaterialita: this.inclusioneModuli.formInclusioneModuli
          .get('idMaterialita')
          ?.getRawValue()?.id,
        idSintesiSostenibilita: this.inclusioneModuli.formInclusioneModuli
          .get('idSintesiSostenibilita')
          ?.getRawValue()?.id,
        idAutovalutazioneCompilata: this.inclusioneModuli.formInclusioneModuli
          .get('idAutovalutazioneCompilata')
          ?.getRawValue()?.id,
        idPianoSostenibilita: this.inclusioneModuli.formInclusioneModuli
          .get('idPianoSostenibilita')
          ?.getRawValue()?.id,
        idBilancioSostenibilita: this.inclusioneModuli.formInclusioneModuli
          .get('idBilancioSostenibilita')
          ?.getRawValue()?.id,
      };

      const idPolicy = this.formPolicySostenibilita.get('id')?.value;
      if (idPolicy) {
        return new Promise((resolve) => {
          this.policyService.putAggiornamentoPolicyStep1(idPolicy).subscribe({
            next: (esito) => {
              resolve(true);
            },
            error: (err) => {
              console.error('erroe salvataggio step1', err);
              resolve(false);
            },
          });
        });
      } else {
        return new Promise((resolve) => {
          this.policyService.postCreazionePolicyStep1(nuovaPolicy).subscribe({
            next: (esito) => {
              this.formPolicySostenibilita.get('id')?.setValue(esito.id);

              this.formPolicySostenibilita.disable();

              resolve(true);
            },
            error: (err) => {
              this.utilityService.openDialog({
                titolo: 'Attenzione',
                descrizione: err.error.message,
                bottoni: [{ nome_btn: 'Ok' }],
              });
              resolve(false);
            },
          });
        });
      }
    } else {
      Object.values(this.formPolicySostenibilita.controls).forEach((control) => {
        control.markAsTouched();
      });
    }
    return false;
  }

  /**
   * Metodo salvataggio STEP  TEMATICHE
   * @returns
   */
  private _salvaStepTematiche(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      if (this.componenteSurvey.stato === 'PUBBLICATO') {
        resolve(true);
        return;
      }

      this.componenteSurvey.salva().subscribe({
        next: (esito) => {
          resolve(esito);
        },
      });
    });
  }

  /**
   * Metodo salvataggio STEP 6 IMPEGNI
   * @returns
   */
  private _salvaStepImpengi(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      if (this.componenteSurvey.stato === 'PUBBLICATO') {
        resolve(true);
        return;
      }
      this.componenteSelImpegniPolicy.salva().subscribe({
        next: (esito) => {
          resolve(esito);
        },
      });
    });
  }

  /**
   * Metodo salvataggio STEP 7 AZIONI E BUONE PRATICHE
   * @returns
   */
  private _salvaStepAzioniBP(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      if (this.componenteSurvey.stato === 'PUBBLICATO') {
        resolve(true);
        return;
      }
      this.componenteSelAzioneBPPolicy.salva().subscribe({
        next: (esito) => {
          resolve(esito);
        },
      });
    });
  }
  /**
   * Metodo salvataggio Certificazioni
   * @returns
   */
  private _salvaStepCertificazioni(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      if (this.componenteSurvey.stato === 'PUBBLICATO') {
        resolve(true);
        return;
      }
      this.componenteSelCertificazioniPolicy.salva().subscribe({
        next: (esito) => {
          resolve(esito);
        },
      });
    });
  }

  private _salvaStepComitati(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.selezionaComitatiPolicy.isComitatiSelezionatiCompilati()) {
        this.selezionaComitatiPolicy.salvaStepComitati().subscribe({
          next: (esito) => {
            resolve(esito);
          },
        });
      } else {
        resolve(false);
      }
    });
  }

  private _salvaPerimetriDestinatari(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.selezionaPerimetroDestinatari.isPerimetriDestinataoriSelezionatiCompilati()) {
        this.selezionaPerimetroDestinatari.salvaPerimetriDestinatari().subscribe({
          next: () => {
            this.utilityService.openSnackBar('Salvataggio effettuato', '', {
              duration: 2000,
              panelClass: ['success-snackbar'],
            });
            resolve(true);
          },
          error: () => {
            resolve(false);
          },
        });
      } else {
        resolve(false);
      }
    });
  }

  /* ********************************************************************** */

  salvataggioSelezioni(stepperIndex: number): Observable<boolean> {
    if (this._policy?.stato === 'PUBBLICATO' || this.isPermessoSoloRead) {
      return of(true);
    }

    switch (stepperIndex) {
      case 2: //Impegni
        this.spinnerOver.show();
        return this.componenteSelImpegniPolicy
          .salva(true)
          .pipe(finalize(() => this.spinnerOver.hide()));
      case 3: //Azioni e buone pratiche
        this.spinnerOver.show();
        return this.componenteSelAzioneBPPolicy
          .salva(true)
          .pipe(finalize(() => this.spinnerOver.hide()));
      case 4: //Certificazioni
        this.spinnerOver.show();
        return this.componenteSelCertificazioniPolicy
          .salva(true)
          .pipe(finalize(() => this.spinnerOver.hide()));
      default:
        return of();
    }
  }

  /**
   * Lista di tutte le assegnazioni delle figure
   * @param stepperIndex index dello stepper in qui sono
   */
  assegnazioni(stepperIndex: number) {
    this.salvataggioSelezioni(stepperIndex)
      .pipe(
        switchMap(() => {
          const dialogAssegnazioniFigAzz = this.dialog.open(DialogAssegnazioniComponent, {
            data: {
              idContesto: this.formPolicySostenibilita.get('id')?.value,
              stato: this.policy?.stato,
              contesto: 'policy',
              isPermessoSoloRead: this.isPermessoSoloRead,
            },
            panelClass: 'dialog-container',
            disableClose: false,
            width: '75%',
            maxHeight: '95%',
            autoFocus: false,
          });

          return dialogAssegnazioniFigAzz.afterClosed();
        }),
      )
      .subscribe(() => {
        if (this._policy?.stato === 'PUBBLICATO') {
          return;
        }

        switch (stepperIndex) {
          case 2: //Impegni
            this._getImpegniPolicy();
            break;
          case 3: //Azioni e buone pratiche
            this._getAzioniBPPolicy();
            break;
          case 4: //Certificazioni
            this._getCertificazioniPolicy();
            break;
          default:
            break;
        }
      });
  }

  async creaComitato() {
    await firstValueFrom(this.selezionaComitatiPolicy.salvaStepComitati());

    const dialogCreaComitato = this.dialog.open(DialogCreaComitatiComponent, {
      data: {
        idAzienda: this.formPolicySostenibilita.get('idAzienda')?.value,
      },
      panelClass: 'dialog-container',
      disableClose: false,
      width: '75%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogCreaComitato.afterClosed().subscribe((result) => {
      if (result) {
        this.selezionaComitatiPolicy.getComitatiConFigureAziendali().subscribe();
      }
    });
  }

  public bottoniListaClick(event: BottoniListaEvent) {
    switch (event.id) {
      case 'modifica':
        this.modificaFigura(event.data);
        break;
      case 'compila':
        this.eleCompilazioneFigura(
          event.data.elementi,
          event.data.nome,
          event.data.figura,
          event.data.id,
        );
        break;
      default:
        console.warn('ATTENZIONE: bottone ' + event.id + ' non riconosciuto');
    }
  }

  /**
   * Modifica figura su cruscotto
   * @param dati
   */
  modificaFigura(dati: any) {
    const dialogAssociaFiguraAziendale = this.dialog.open(DialogAssociaFiguraAziendaleComponent, {
      data: {
        figura: { id: dati.id },
      },
      panelClass: 'dialog-container',
      disableClose: false,
      width: '50%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogAssociaFiguraAziendale.afterClosed().subscribe((idFiguraNuova) => {
      const idFiguraPrecedente = dati?.id;

      const idPolicySostenibilita = this.formPolicySostenibilita.get('id')?.value;

      if (idPolicySostenibilita && idFiguraPrecedente && idFiguraNuova) {
        this.policyService
          .putCambiaFigura(idPolicySostenibilita, idFiguraPrecedente, idFiguraNuova)
          .subscribe({
            next: () => {
              this.tabella.caricaDati();
            },
            error: (err) => {
              this.tabella.caricaDati();
              console.error(err);
            },
          });
      }
    });
  }

  private async _pubblicazionePolicy(desc?: string): Promise<Observable<boolean> | undefined> {
    const idPolicySostenibilita = this.formPolicySostenibilita.get('id')?.value;
    let titolo: string = 'Pubblicazione Policy di Sostenibilità';
    let descrizione: string = `
        <div>
          <p>
            <strong>Si prega di notare che questa operazione pubblicherà la Policy di Sostenibilità.</strong>
          </p>
          <ul>
            <li>La pubblicazione è definitiva e <strong>NON</strong> potrà essere annullata.</li>
            <li>Inoltre non sarà più possibile <strong>aggiungere</strong> o <strong>modificare</strong> le informazioni precedentemente configurate.</li>
          </ul>
          <p><strong>Vuoi procedere ${desc ? desc : ' '}?</strong></p>
        </div>
      `;

    const dialog = await this.utilityService.openDialog({
      titolo: titolo,
      descrizione: descrizione,
      fontWeight: '500',
      bottoni: [
        { nome_btn: 'No', id_btn: 'N' },
        { nome_btn: 'Si', id_btn: 'S' },
      ],
    });

    const valDialog = await firstValueFrom(dialog.beforeClosed());
    if (valDialog === 'N') {
      return of(false);
    }
    this.spinnerOver.show();
    await firstValueFrom(this.policyService.pubblicaPolicy(idPolicySostenibilita!));
    return of(true);
  }

  /**
   * Get cruscotto filtrato per figura
   * @param idFigura
   * @param idPolicySostenibilita
   * @returns
   */
  getFiguraCruscotto(idFigura: string, idPolicySostenibilita: string) {
    return new Promise((resolve, reject) => {
      let filtroFiguraSelezionata: Filters = {
        values: [idFigura],
        operator: 'eq',
        chiave: 'id',
      };

      this.policyService
        .getCruscotti(idPolicySostenibilita ?? '', 0, 1000, '', [filtroFiguraSelezionata])
        .subscribe({
          next: (data) => resolve(data),
          error: (err) => reject(new Error(err)),
        });
    });
  }

  /**
   *
   * @param elementiCruscotto
   * @param nome
   * @param figura
   */
  public async eleCompilazioneFigura(
    elementiCruscotto: ElementiCruscotto[],
    nome: string,
    figura: string,
    idFigura: string,
  ) {
    const idPolicySostenibilita = this.formPolicySostenibilita.get('id')?.value;

    if (idPolicySostenibilita) {
      if (!this.isPubblicato() && !this.isPermessoSoloRead) {
        /* --- Modifica richiesta: Se ci sono elementi precompilati lo posso sapere solamente se pubblico
          il questionario, una volta pubblicato, il BE calcola le precompilazioni, mi rifaccio la get del cruscotto filtrato
          per idFigura selezionata e mi reperisco gli elementi aggiornati e precompilati. --- */

        const risultatoObservable = await this._pubblicazionePolicy('alla compilazione');
        if (risultatoObservable) {
          const risultato = await firstValueFrom(risultatoObservable);
          if (!risultato) {
            return;
          }
          try {
            // CHIAMO LA FIGURA FILTRTA E ASPETTO RISPOSTA
            const figura: any = await this.getFiguraCruscotto(idFigura!, idPolicySostenibilita!);
            elementiCruscotto = figura?.content[0]?.elementi;
          } catch (err) {
            console.error(err);
          }
        }
        this.spinnerOver.hide();
      }

      const dialogCompilazioneFigure = this.dialog.open(DialogCompilazioneFigureComponent, {
        data: {
          elementiCruscotto,
          idPolicySostenibilita,
          nome,
          figura,
          isPermessoSoloRead: this.isPermessoSoloRead,
        },
        panelClass: 'dialog-container',
        disableClose: false,
        width: '75%',
        maxHeight: '95%',
        autoFocus: false,
      });

      dialogCompilazioneFigure
        .afterClosed()
        .pipe(
          switchMap(() => {
            this.spinnerOver.show();
            return this._getQuestionarioPolicy(idPolicySostenibilita);
          }),
        )
        .subscribe(() => {
          this.tabella.caricaDati();
          this.cmpTotaliCruscotto.getTotaliCruscotto();
          this.spinnerOver.hide();
        });
    }
  }

  async inviaTutti() {
    const idPolicySostenibilita = this.formPolicySostenibilita.get('id')?.value;

    if (idPolicySostenibilita) {
      const testiMail = await firstValueFrom(
        this.policyService.getTemplateMail(idPolicySostenibilita),
      );

      if (!testiMail?.mailInvio) {
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: "Prima di fare l'invio compilare i Testi Mail",
          bottoni: [{ nome_btn: 'Ok' }],
        });
        return;
      }

      if (this._policy.stato !== 'PUBBLICATO') {
        const risultatoObservable = await this._pubblicazionePolicy("con l'invio mail");
        if (risultatoObservable) {
          const risultato = await firstValueFrom(risultatoObservable);
          if (!risultato) {
            return;
          }
        }
        this.spinnerOver.hide();
      }
      try {
        this.spinnerOver.show();
        await firstValueFrom(this.policyService.inviaMailMultiple(idPolicySostenibilita));
        await firstValueFrom(this._getQuestionarioPolicy(idPolicySostenibilita));
        this.tabella.caricaDati();
        this.utilityService.openSnackBar('Mail inviata ', '', {
          duration: 2000,
          panelClass: ['success-snackbar'],
        });
        this.spinnerOver.hide();
      } catch (error: any) {
        console.error(error);
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: error?.error?.message || 'Errore invio mail',
          bottoni: [{ nome_btn: 'Ok' }],
        });
        this.spinnerOver.hide();
      }
    }
  }

  async notificaTutti() {
    const idPolicySostenibilita = this.formPolicySostenibilita.get('id')?.value;

    if (idPolicySostenibilita) {
      const testiMail = await firstValueFrom(
        this.policyService.getTemplateMail(idPolicySostenibilita),
      );

      if (!testiMail?.mailInvio) {
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: "Prima di fare l'invio compilare i Testi Mail",
          bottoni: [{ nome_btn: 'Ok' }],
        });
        return;
      }

      const dialog = await this.utilityService.openDialog({
        titolo: 'Confermare invio?',
        descrizione: 'Sarà inviata una notifica a tutte le figure che hanno ricevuto la mail',
        bottoni: [
          {
            nome_btn: 'No',
            id_btn: 'N',
          },
          {
            nome_btn: 'Si',
            id_btn: 'S',
          },
        ],
      });

      const valDialog = await firstValueFrom(dialog.beforeClosed());
      if (valDialog === 'N') {
        return;
      }

      try {
        this.spinnerOver.show();
        await firstValueFrom(this.policyService.inviaNotificaMultiple(idPolicySostenibilita));
        await firstValueFrom(this._getQuestionarioPolicy(idPolicySostenibilita));

        this.tabella.caricaDati();

        this.utilityService.openSnackBar('Notifica inviata ', '', {
          duration: 2000,
          panelClass: ['success-snackbar'],
        });
        this.spinnerOver.hide();
      } catch (error: any) {
        console.error(error);
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: error?.error?.message || 'Errore invio notifiche',
          bottoni: [{ nome_btn: 'Ok' }],
        });
        this.spinnerOver.hide();
      }
    }
  }

  template() {
    const idPolicySostenibilita = this.formPolicySostenibilita.get('id')?.value;

    if (idPolicySostenibilita) {
      const dialogCreaTemplateMail = this.dialog.open(DialogCreaTemplateMailComponent, {
        data: {
          idModulo: idPolicySostenibilita,
          tipoModulo: 'POLICY',
          isPermessoSoloRead: this.isPermessoSoloRead,
        },
        panelClass: 'dialog-container-scrollbar',
        disableClose: false,
        width: '95%',
        height: '95%',
        autoFocus: false,
      });

      dialogCreaTemplateMail.afterClosed().subscribe(() => {});
    }
  }

  /* ------------------------- STAMPA -------------------------*/

  public async stampa() {
    const idPolicy = this.formPolicySostenibilita.get('id')?.value;
    this.spinnerOver.show();
    await this.cmpTotaliCruscotto.getTotaliCruscotto();
    this.spinnerOver.hide();

    if (this.cmpTotaliCruscotto.isElementiNonCompilati(['CERTIFICAZIONI', 'AZIONI', 'IMPEGNI'])) {
      let titolo: string = 'Stampa';
      let descrizione: string = `
      <div>
        <p>
          Non sono state <strong>completate</strong> tutte le <strong>compilazioni</strong>.
        </p>
        <p><strong>Vuoi procedere?</strong></p>
      </div>`;

      const dialog = await this.utilityService.openDialog({
        titolo: titolo,
        descrizione: descrizione,
        fontWeight: '500',
        bottoni: [
          { nome_btn: 'No', id_btn: 'N' },
          { nome_btn: 'Si', id_btn: 'S' },
        ],
      });

      const valDialog = await firstValueFrom(dialog.beforeClosed());
      if (valDialog === 'N') {
        return of(false);
      }
    }

    if (!this.cfgStampaComponent.cfgStampa) {
      console.error('NESSUNA CFG STAMPA DA SALVARE');
      return;
    }

    this.spinnerOver.show();

    if (idPolicy && this.cfgStampaComponent.cfgStampa) {
      this.fnSalvaCfgStampa(this.cfgStampaComponent.cfgStampa)
        .pipe(
          switchMap((result: any) => {
            if (result) {
              return this.policyService.postStampaPolicy(idPolicy);
            } else {
              return of();
            }
          }),
        )
        .subscribe({
          next: (urlStampa) => {
            window.open(urlStampa?.body, '_blank');

            this.spinnerOver.hide();
          },
          error: (err) => {
            console.error(err);

            this.spinnerOver.hide();

            this.utilityService.openDialog({
              titolo: 'Attenzione',
              descrizione: 'Stampa non riuscita. Verificare le configurazioni e riprovare.',
              bottoni: [{ nome_btn: 'Ok' }],
            });
          },
        });
    }
    return;
  }

  /**
   * Lancia il salvataggio della configurazione, passando dal componente.
   */
  public salvaCfgStampa() {
    if (!this.cfgStampaComponent.cfgStampa) {
      console.error('NESSUNA CFG STAMPA DA STAMPARE');
      return;
    }

    this.spinnerOver.show();

    this.fnSalvaCfgStampa(this.cfgStampaComponent.cfgStampa).subscribe((esito) => {
      if (!esito) {
        // Salvataggio fallito
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione:
            'Salvataggio configurazione non riuscito. Verificare le informazioni e riprovare.',
          bottoni: [{ nome_btn: 'Ok' }],
        });
      }

      this.spinnerOver.hide();
    });
  }

  /**
   *
   * @returns Funzione di get cfg stampa da impostare sul componente cfgStampaComponent
   */
  public fnGetConfigStampa = () => {
    const idPolicy = this.formPolicySostenibilita.get('id')?.value;
    if (idPolicy) {
      return this.policyService.getConfigStampa(idPolicy);
    } else {
      return throwError(() => 'ID Policy non valorizzato');
    }
  };

  /**
   * Funzione di salvataggio cfg stampa da impostare sul componente cfgStampaComponent
   * @param grpCfgStampa
   * @returns
   */
  public fnSalvaCfgStampa = (grpCfgStampa: GruppoCfgStampa) => {
    const idPolicy = this.formPolicySostenibilita.get('id')?.value;

    if (idPolicy) {
      if (this.isPermessoSoloRead) {
        return of(true);
      }

      return this.policyService.postSalvaElementiStampa(idPolicy, grpCfgStampa);
    } else {
      return throwError(() => 'ID Policy non valorizzato');
    }
  };

  /**
   * Metodo che mi fa l'importazione del file immagine
   * @param elemStampa
   */
  public fnImportaImmagine = (file: File, chiaveCfg: string) => {
    const listaId: any = {
      idAzienda: this.formPolicySostenibilita.get('idAzienda')?.value,
      idPolicySostenibilita: this.formPolicySostenibilita.get('id')?.value,
      chiaveCfg,
    };

    return this.importazioniService.importImgStampaPolicy(file, {}, listaId);
  };

  /**
   * Metodo per eliminazione immagine in cfg stampa
   * Viene rimosso da google cloud storage
   */
  public fnEliminaImg = (chiaveCfg: string) => {
    const listaId: any = {
      idAzienda: this.formPolicySostenibilita.get('idAzienda')?.value,
      idPolicySostenibilita: this.formPolicySostenibilita.get('id')?.value,
      chiaveCfg,
    };

    return this.importazioniService.deleteImgStampaPolicy(listaId);
  };

  public toggleLoading(mostra: boolean) {
    if (mostra) {
      this.spinnerOver.show();
    } else {
      this.spinnerOver.hide();
    }
  }

  ctrAnnoPolicyUtilizzata(anno: string) {
    return this.isAnnoSettoreValid(anno, this.formPolicySostenibilita.get('settori')?.value?.id);
  }

  ctrSettorePolicyUtilizzata(settore: Settore) {
    const anno = this.formPolicySostenibilita.get('anno')?.value;
    return this.isAnnoSettoreValid(anno, settore?.id);
  }

  private isAnnoSettoreValid(anno: string | undefined, settoreId: string | undefined) {
    return anno && settoreId && this.mappaAnnoSettore[anno]?.[settoreId] ? true : false;
  }

  /**
   * Metodo che gestisce la logica della navigazione sugli stepper
   */
  gestioneStepperPolicy() {
    setTimeout(() => {
      this.stepper.steps.forEach((step, idx) => {
        step.select = async () => {
          // Se torno indietro non faccio ne controlli ne salvataggi
          if (idx < this.stepper.selectedIndex || this.isPermessoSoloRead) {
            return (this.stepper.selectedIndex = idx);
          }

          /* Se step selezionato è completed devo controllare gli step in mezzo
           Esempio (sono su STEP 1 seleziono STEP 6 , devo controllare STEP 2-3-4-5) */
          if (this.stepper.steps.get(idx)?.completed) {
            return (this.stepper.selectedIndex = await this.ctrStep(idx));
          }

          if (idx === this.stepper.selectedIndex + 1) {
            // linear
            const isSalvato = await this.avanti();

            if (isSalvato) {
              return (this.stepper.selectedIndex = idx);
            }
          }
          return;
        };
      });
    }, 0);
  }

  private async ctrStep(stepperSelezionato: number): Promise<number> {
    const stepperCorrente = this.stepper.selectedIndex;

    if (stepperSelezionato > stepperCorrente) {
      for (let index = stepperCorrente; index < stepperSelezionato; index++) {
        // Salvo step corrente
        if (stepperCorrente === index) {
          const isSalvato = await this.avanti();
          if (!isSalvato) {
            return stepperCorrente;
          }
        }

        // Controllo step by step e ritorno l'index dove da errore
        if (await this.ritornoControllo(index)) {
          return index;
        }
      }
    }

    return stepperSelezionato;
  }

  private async ritornoControllo(stepperDaControllare: number): Promise<boolean> {
    let isCtrFallito: boolean = false;
    switch (stepperDaControllare) {
      case 1:
        isCtrFallito = this.componenteSurvey.ctrSalva();
        break;

      case 2: {
        const esito = await this._getImpegniPolicy();
        if (esito) {
          isCtrFallito = this.componenteSelImpegniPolicy.ctrStepper('impegno');
        }
        break;
      }

      case 3: {
        const esito = await this._getAzioniBPPolicy();
        if (esito) {
          isCtrFallito = this.componenteSelAzioneBPPolicy.ctrStepper('azione o buona pratica');
        }
        break;
      }

      case 5: {
        const esito = await this._getComitatiPolicy();
        if (esito) {
          isCtrFallito = !this.selezionaComitatiPolicy.isComitatiSelezionatiCompilati();
        }
        break;
      }

      case 7: {
        {
          const esito = await this._getPerimetriDestinatari();
          if (esito) {
            isCtrFallito =
              !this.selezionaPerimetroDestinatari.isPerimetriDestinataoriSelezionatiCompilati();
          }
          break;
        }
      }

      default:
        break;
    }
    return isCtrFallito;
  }

  /**
   * Viene richiamato nel momento in cui si caricano le tamatiche (questionario)
   */
  public completaStep() {
    if (this.isPubblicato() || this.isArchiviato()) {
      this.stepper.steps.forEach((step, idx) => {
        step.completed = true;
      });
    }
  }
}
